
import ExcludedGainCategoriesComponent from "@/components/system_settings/ExcludedGainCategories.vue"

export default({
  components: {
    ExcludedGainCategoriesComponent,
  }
})
